export const ready = 0;
export const presenting = 1;
export const waiting = 2;